module.exports = __webpack_public_path__ + "img/fujitrans_logo.ccc44aa6.jpg";